export const refreshActionTypes = {
  SET_REFRESH_FN: 'SET_REFRESH_FN',
};

export const setRefreshFn = (refreshFn) => ({
  type: refreshActionTypes.SET_REFRESH_FN,
  payload: { refreshFn },
});
